import { useQuery } from '@tanstack/react-query';
import { api } from '../services/axiosConfig';
import { SystemIntel } from '../types';

/** Name -> full intel, for the `/system/:slug` permalink pages. Member-only
 * like the rest of the app; a deep link from an unauthenticated browser is
 * carried through SSO by Start.tsx's `returnTo` rather than being served
 * anonymously. */
export const fetchSystemBySlug = (slug: string) =>
  api.get<SystemIntel>(`/api/intel/system/by-name/${encodeURIComponent(slug)}`).then((r) => r.data);

/** Shared by the system page and every one of its tabs — one query key, so
 * switching tabs reads the cache instead of refetching. */
export const useSystemBySlug = (slug: string) =>
  useQuery({
    queryKey: ['system-by-name', slug.toLowerCase()],
    queryFn: () => fetchSystemBySlug(slug),
    enabled: !!slug,
    retry: false,
  });
